import React from 'react';
import { SvgIcon } from '@mui/material';

const SvgReport = (props) => (
  <SvgIcon {...props} title="Report">
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#Report_svg__a)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.528.098C.838.336.328.85.095 1.542c-.15.448-.15 17.47.001 17.919a2.253 2.253 0 0 0 1.446 1.443c.436.147 6.128.15 6.368.002.463-.282.463-1.03 0-1.313-.147-.09-.241-.093-2.894-.093-3.261 0-3.303-.008-3.464-.588-.073-.262-.073-16.562 0-16.824.066-.237.3-.47.536-.536.258-.072 10.7-.073 10.967-.001.28.075 3.319 3.115 3.394 3.394.033.123.05 1.035.05 2.625.001 2.35.005 2.443.094 2.59.282.463 1.03.463 1.314 0 .092-.149.094-.219.082-2.894l-.013-2.743-.178-.375c-.275-.58-3.367-3.67-3.947-3.946l-.375-.179-5.835-.01C1.878.003 1.8.003 1.528.098ZM3.34 6.093c-.462.282-.462 1.031 0 1.313.24.147 11.081.147 11.322 0 .462-.282.462-1.03 0-1.313-.24-.146-11.082-.146-11.322 0Zm0 4.5c-.462.282-.462 1.031 0 1.313.24.146 8.832.146 9.072 0 .462-.282.462-1.03 0-1.313-.24-.146-8.832-.146-9.072 0Zm13.16 1.48c-.687.18-.847.3-3.421 2.553-2.512 2.2-2.578 2.267-2.578 2.637 0 .69.726.997 1.294.545l.182-.145L12 20c.027 2.696.028 2.701.603 3.314.649.692.61.686 4.647.686 4.036 0 3.998.006 4.647-.686.575-.613.576-.618.603-3.314l.023-2.337.182.145c.703.558 1.637-.15 1.213-.92-.163-.296-4.863-4.352-5.285-4.56-.657-.326-1.484-.424-2.133-.255Zm1.34 1.59c.164.072.697.506 1.7 1.383l1.46 1.277v2.702c0 3.494.007 3.474-1.136 3.475H19.5v-1.337c0-1.463-.026-1.638-.312-2.1-1.01-1.633-3.478-1.345-4.093.479-.087.258-.095.399-.095 1.62V22.5h-.363c-1.143-.001-1.136.02-1.137-3.475v-2.701l1.43-1.252c1.901-1.663 2.112-1.765 2.91-1.41Zm-14.5 1.43c-.462.282-.462 1.031 0 1.313.238.145 4.334.145 4.571 0 .463-.282.463-1.03 0-1.313-.237-.144-4.333-.144-4.57 0Zm14.24 4.526c.37.186.416.379.419 1.744L18 22.5h-1.5v-1.113c0-.637.022-1.19.05-1.292.129-.465.609-.687 1.028-.476Z"
          fill="#017163"
        />
      </g>
      <defs>
        <clipPath id="Report_svg__a">
          <path fill="#fff" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  </SvgIcon>
);

export default SvgReport;
